import Signal from 'libs/signals';

const UserInvites = Signal({
  userInvitations: [],
  selectedUserInvitation: null,
});

export default UserInvites;
